"use strict";

exports.__esModule = true;
var regionUphostMap = exports.regionUphostMap = {
  z0: {
    srcUphost: "up.qiniup.com",
    cdnUphost: "upload.qiniup.com"
  },
  z1: {
    srcUphost: "up-z1.qiniup.com",
    cdnUphost: "upload-z1.qiniup.com"
  },
  z2: {
    srcUphost: "up-z2.qiniup.com",
    cdnUphost: "upload-z2.qiniup.com"
  },
  na0: {
    srcUphost: "up-na0.qiniup.com",
    cdnUphost: "upload-na0.qiniup.com"
  },
  as0: {
    srcUphost: "up-as0.qiniup.com",
    cdnUphost: "upload-as0.qiniup.com"
  }
};

var region = exports.region = {
  z0: "z0",
  z1: "z1",
  z2: "z2",
  na0: "na0",
  as0: "as0"
};


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 37
// module chunks = 0